const CommunitySettingCodes = {
    CURRENCY: "CURRENCY"
}

const CommunitySettingDefaults = {
    CURRENCY: "CAD"
}

export { CommunitySettingCodes, CommunitySettingDefaults };